import {Camera, CameraResultType, CameraSource, Photo} from '@capacitor/camera'
import {useCallback} from 'react'
import {useTranslate} from 'react-admin'

import {base64ToArrayBuffer} from '../utils/buffers'

const useTakePicture = () => {
  const translate = useTranslate()
  return useCallback(() => takePicture({
    promptLabelCancel: translate('hooks.useTakePicture.promptLabelCancel'),
    promptLabelHeader: translate('hooks.useTakePicture.promptLabelHeader'),
    promptLabelPhoto: translate('hooks.useTakePicture.promptLabelPhoto'),
    promptLabelPicture: translate('hooks.useTakePicture.promptLabelPicture'),
  }), [translate])
}

const takePicture = async ({
  promptLabelCancel,
  promptLabelHeader,
  promptLabelPhoto,
  promptLabelPicture,
}: TakePictureOptions): Promise<FileAttachment<undefined> | undefined> => {
  let picture: Photo | undefined
  try {
    picture = await Camera.getPhoto({
      // TODO: We could actually allow picture editing after it was taken, however the
      //       UX is a bit odd. Set it to `true` to find out. However discuss with UX team
      //       how we could turn this into a better UX as picture editing might be good to
      //       provide to the user.
      allowEditing: false,
      height: 5000,
      promptLabelCancel,
      promptLabelHeader,
      promptLabelPhoto,
      promptLabelPicture,
      resultType: CameraResultType.Base64,
      saveToGallery: true,
      source: CameraSource.Camera,
      width: 5000,
    })
  }
  catch (e) {
    if (
      !['No image picked', 'User cancelled photos app'].includes((e as Error).message)
    ) {
      console.error(e)
    }
    return
  }
  const arrayBuffer = base64ToArrayBuffer(picture.base64String as string)
  const file = new File(
    [arrayBuffer],
    `Picture-${Date.now() / 1000 | 0}.${picture.format}`,
    {type: `image/${picture.format}`},
  )
  return {
    encodedContent: undefined,
    file,
    filename: file.name,
    mimeType: file.type,
  }
}

interface TakePictureOptions {
  promptLabelCancel: string
  promptLabelHeader: string
  promptLabelPhoto: string
  promptLabelPicture: string
}

export default useTakePicture
